// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--ion-color-tertiary);
  color: #fff;
}

ion-toolbar {
  --background: var(--ion-color-tertiary);
  height: 2.5rem;
}

p,
h5 {
  color: #fff;
}

.toolbar-container {
  height: 2.5rem;
}

.game-detail-navbar ion-button {
  width: 65px !important;
  height: 54px;
  transform: translateY(-8px);
  --background-hover-opacity: 0;
}
.game-detail-navbar ion-button ion-icon {
  font-size: 2.5rem !important;
}
@media screen and (max-width: 550px) {
  .game-detail-navbar ion-button {
    /* Add responsive styles here if needed */
  }
}
.game-detail-navbar ion-title {
  text-align: center;
  font-size: 2rem;
  font-weight: 550;
  line-height: 2.5rem;
  transform: translateY(-8px);
}
@media screen and (max-width: 550px) {
  .game-detail-navbar ion-title {
    font-size: 1rem;
  }
}
@media screen and (max-width: 350px) {
  .game-detail-navbar ion-title {
    font-size: 0.875rem;
  }
}

.image-container {
  display: flex;
  min-height: 12rem;
}
.image-container img {
  width: 100%;
  max-height: 15rem;
  min-height: 12rem;
}

p.category-text {
  font-size: 1rem;
  color: #FFF;
  font-weight: 700;
  text-transform: lowercase;
}
p.category-text::first-letter {
  text-transform: uppercase;
}

.info-text {
  color: #FFF;
}
.info-text h5 {
  margin: 1px !important;
}
.info-text p {
  margin: 0.5rem 0 0 0 !important;
}

ion-button {
  min-height: 2.5rem;
}

.game-detail-description-table {
  margin-top: 1rem;
}
.game-detail-description-table table {
  border-collapse: separate;
  width: 100%;
  border: 1px solid #FFF;
  overflow: hidden;
  border-radius: 0.5rem;
}
.game-detail-description-table table h5 {
  color: #FFF;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1rem;
  text-align: left;
}
.game-detail-description-table table h5 span.normal-weight {
  font-weight: 400;
}
.game-detail-description-table table h5 span {
  font-weight: 700;
}
.game-detail-description-table table td {
  padding-left: 1rem;
}
.game-detail-description-table .game-detail-table td {
  border-bottom: 1px solid #FFF;
}
.game-detail-description-table .game-detail-table tr:last-child td {
  border-bottom: none;
}

.game-detail-description-box {
  color: #FFF;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 0.5rem;
}
.game-detail-description-box h5 {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1rem;
  text-align: left;
}
.game-detail-description-box p {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  text-align: left;
  margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/game-details/game-details.component.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,WAAA;AADF;;AAIA;EACE,uCAAA;EACA,cAAA;AADF;;AAIA;;EAEE,WAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAKE;EACE,sBAAA;EACA,YAAA;EACA,2BAAA;EACA,6BAAA;AAFJ;AAII;EACE,4BAAA;AAFN;AAKI;EAVF;IAWI,yCAAA;EAFJ;AACF;AAKE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;AAHJ;AAKI;EAPF;IAQI,eAAA;EAFJ;AACF;AAII;EAXF;IAYI,mBAAA;EADJ;AACF;;AAKA;EACE,aAAA;EACA,iBAAA;AAFF;AAIE;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,WAAA;AAJF;AAME;EACE,sBAAA;AAJJ;AAOE;EACE,+BAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,gBAAA;AANF;AAQE;EACE,yBAAA;EACA,WAAA;EACA,sBAlGW;EAmGX,gBAAA;EACA,qBAAA;AANJ;AAQI;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AANN;AAQM;EACE,gBAAA;AANR;AASM;EACE,gBAAA;AAPR;AAWI;EAEE,kBAAA;AAVN;AAeE;EACE,6BA9HW;AAiHf;AAgBE;EACE,mBAAA;AAdJ;;AAkBA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAfF;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAhBJ","sourcesContent":["$table-border: 1px solid #FFF;\n\nion-content {\n  --background: var(--ion-color-tertiary);\n  color: #fff;\n}\n\nion-toolbar {\n  --background: var(--ion-color-tertiary);\n  height: 2.5rem;\n}\n\np,\nh5 {\n  color: #fff;\n}\n\n.toolbar-container {\n  height: 2.5rem;\n}\n\n.game-detail-navbar {\n  ion-button {\n    width: 65px !important;\n    height: 54px;\n    transform: translateY(-8px);\n    --background-hover-opacity: 0;\n\n    ion-icon {\n      font-size: 2.5rem !important;\n    }\n\n    @media screen and (max-width: 550px) {\n      /* Add responsive styles here if needed */\n    }\n  }\n\n  ion-title {\n    text-align: center;\n    font-size: 2rem;\n    font-weight: 550;\n    line-height: 2.5rem;\n    transform: translateY(-8px);\n\n    @media screen and (max-width: 550px) {\n      font-size: 1rem;\n    }\n\n    @media screen and (max-width: 350px) {\n      font-size: .875rem;\n    }\n  }\n}\n\n.image-container {\n  display: flex;\n  min-height: 12rem;\n\n  img {\n    width: 100%;\n    max-height: 15rem;\n    min-height: 12rem;\n  }\n}\n\np.category-text {\n  font-size: 1rem;\n  color: #FFF;\n  font-weight: 700;\n  text-transform: lowercase;\n\n  &::first-letter {\n    text-transform: uppercase;\n  }\n}\n\n.info-text {\n  color: #FFF;\n\n  h5 {\n    margin: 1px !important;\n  }\n\n  p {\n    margin: .5rem 0 0 0 !important;\n  }\n}\n\nion-button {\n  min-height: 2.5rem;\n}\n\n.game-detail-description-table {\n  margin-top: 1rem;\n\n  table {\n    border-collapse: separate;\n    width: 100%;\n    border: $table-border;\n    overflow: hidden;\n    border-radius: .5rem;\n\n    h5 {\n      color: #FFF;\n      font-size: .875rem;\n      font-weight: 400;\n      line-height: 1rem;\n      text-align: left;\n\n      span.normal-weight {\n        font-weight: 400;\n      }\n\n      span {\n        font-weight: 700;\n      }\n    }\n\n    td {\n      // border: $table-border;\n      padding-left: 1rem;\n    }\n  }\n\n\n  .game-detail-table td {\n    border-bottom: $table-border;\n  }\n\n  .game-detail-table tr:last-child td {\n    border-bottom: none;\n  }\n}\n\n.game-detail-description-box {\n  color: #FFF;\n  padding: 1rem;\n  margin-top: 1rem;\n  border-radius: .5rem;\n\n  h5 {\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 1rem;\n    text-align: left;\n  }\n\n  p {\n    font-size: .75rem;\n    font-weight: 400;\n    line-height: 1rem;\n    text-align: left;\n    margin: 0px\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
